<template>
    <div class="drag">
        <div class="drag-box">
            <v-card
                flat
                :class="classes"
                @drop.prevent="onFileDrop($event)"
                @dragover.prevent="dragover = true"
                @dragenter.prevent="dragover = true"
                @dragleave.prevent="dragover = false"
            >
                <v-card-text>
                    <div class="d-flex flex-column" dense align="center" justify="center">
                        <v-icon size="20">mdi-monitor</v-icon>
                        <p class="p-info">{{ text }}</p>
                        <input
                            type="file"
                            name="file_input"
                            ref="file_input"
                            :accept="acceptExtensions.join(',')"
                            placeholder=""
                            :disabled="disabled"
                            @click="reset($event)"
                            @change="onFileInputChange($event)"
                        />
                        <p class="p-max-file-size" v-html="$t('app.max_size', {size: humanSize})" />
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import toastMixin from "@/Shared/toastMixin";
import {i18n} from "@/i18n";
import _ from "lodash";
import {toRealSize, toHumanSize} from "@/helpers";

export default {
    name: "DragAndDropFilePicker",

    mixins: [toastMixin],

    props: {
        cardClass: {
            default: '',
        },

        text: {
            type: String,
            default: i18n.t('app.from_your_computer'),
        },

        maxSize: {
            type: String,
            default: '50MB',
        },

        acceptExtensions: {
            type: Array,

            default: () => ([
                '.xls',
                '.xlsx',
            ]),
        }
    },

    data: () => ({
        dragover: false,

        file: {},

        response: {
            name: '',
            extension: '',
            uuid: '',
            file: {},
        },
    }),

    methods: {
        onFileDrop(event) {
            event.preventDefault();
            this.dragover = false;

            this.validateAndSend(event.dataTransfer.files);
        },

        onFileInputChange(event) {
            this.validateAndSend(event.target.files);
        },

        validateAndSend(files) {
            if(files.length > 1){
                console.warn(`the user send ${files.length}, only the first one will be process`);
            }

            const file = _.first(files);

            if(!this.validate(file)) {
                return;
            }

            this.$emit('select', file);
        },

        validate(file) {
            //warning: lazy validation (only be extension)
            const extension = file.name.split('.').pop();
            if(!this.acceptExtensions.inArray(`.${extension}`)){
                const title = this.$t('app.file_extension_invalid', {
                    extension: extension,
                });
                const message = this.$t('app.file_accepted_extensions', {
                    extensions: this.acceptExtensions.join(', '),
                });

                this.toast().error(title, message);

                return false;
            }

            //size validation
            const size = file.size;
            if(size > this.size){
                const title = this.$t('app.file_size_invalid');
                const message = this.$t('app.file_size_invalid_detail', {
                    current: this.$options.filters.toHumanSize(size),
                    expected: this.humanSize,
                });

                this.toast().error(title, message);

                return false;
            }

            return true;
        },

        reset() {
            this.file = {};
            this.response = {};
        },
    },

    computed: {
        /**
         * Returns the max allowed size measured in bytes
         *
         * @returns {number}
         */
        size() {
            return toRealSize(this.maxSize);
        },

        /**
         * @see toHumanSize
         * @returns {`${number}B`}
         */
        humanSize() {
            return toHumanSize(this.size);
        },

        disabled() {
            return false;
        },

        classes() {
            let classes = [this.cardClass];

            if(this.dragover){
                classes.push('grey', 'lighten-2');
            }

            return classes;
        },
    },

    filters: {
        /**
         * @see toHumanSize
         * @returns {string}
         */
        toHumanSize: toHumanSize,
    },
}
</script>

<style scoped>

</style>
